<template>
  <div class="q-panel">
    <div
      v-if="headerText != null"
      class="q-panel-header"
    >
      {{ headerText }}
    </div>
    <div class="q-panel-body">
      <slot />
    </div>
    <div
      v-if="$slots.footer"
      class="q-panel-footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>

  export default {
    name: 'QPanel',

    props: {
      headerText: {
        type: String,
        default: null
      }
    }
  };
</script>

<style scoped>
  .q-panel {
    background-color: #fff;
    border: 1px solid #cfdbe2;
    box-shadow: 0 1px 1px rgba(0,0,0,.05);
    border-radius: 4px;
    margin-bottom: 15px;
  }

  .q-panel-header{
    border-bottom: 1px solid #cfdbe2;
    padding: 10px;
  }
  .q-panel-body{
  }
  .q-panel-footer{
    padding: 10px 15px;
    background-color: #fafafa;
    border-top: 1px solid #eee;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
</style>